(function () {

  'use strict';

  function pxOidcForm(IdpProviderService, RegexModel, toastr, $filter) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/oidc/oidcForm/oidcForm.template.html',
      link: function (scope) {
        scope.descriptor = IdpProviderService.descriptorByType('oidc');
        scope.illegalChars = new RegexModel().illegalChars_v2();

        scope.idProvider = {
          name: null,
          client_id: null,
          client_secret: null,
          discovery_document_url: null
        };
        scope.idProviderInvalid = true;
        scope.nameCaptionTranslated = $filter('translate')('Name').toLowerCase();

        scope.testForm = function () {
          const required = {
            name: verifyDisplayName(),
            client_id: verifyClientId(),
            client_secret: verifyClientSecret(),
            discovery_document_url: verifyDiscoveryDocumentUrl()
          };

          scope.name = {
            valid: verifyDisplayName()
          };

          const requirementsFulfilled = Object.values(required).every(function (value) {
            return value === true;
          });

          scope.idProviderInvalid = !requirementsFulfilled;
        };

        function verifyDisplayName() {
          return scope.idProvider.name?.match(scope.illegalChars.regex) ? false : true;
        }

        function verifyClientId() {
          return scope.idProvider.client_id ? true : false;
        }

        function verifyClientSecret() {
          return scope.idProvider.client_secret ? true : false;
        }

        function verifyDiscoveryDocumentUrl() {
          return scope.idProvider.discovery_document_url ? true : false;
        }

        scope.submit = function () {
          IdpProviderService.create(scope.tenant, 'oidc', scope.idProvider).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function (error) {
            IdpProviderService.handleCreateError(error, scope.descriptor, scope.tenant);
          });
          scope.callback();
        };
      }
    };
  }

  pxOidcForm.$inject = ['IdpProviderService', 'RegexModel', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxOidcForm', pxOidcForm);

})();
